<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div id="app">
    <router-view class="router-view" v-slot="{ Component }">
      <transition :name="transitionName">
        <component :is="Component" />
      </transition>
    </router-view>
    <!-- <goback-mini v-show="isShow"></goback-mini> 自定义返回小程序原生页面--> 
    <float-icons padding="10 10 60 10" class="icons-warp" v-show="isShow" @click="goBack">
      <div class="float-icon-item">
        <img src="./assets/my-device.png" >
        <span >设备</span>
      </div>
    </float-icons>
  </div>
</template>

<script>
import { onMounted } from 'vue'
// import gobackMini from '@/components/GobackMini'
import FloatIcons from '@/components/Sicons'
import { reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
  export default {
    components: {
      'float-icons': FloatIcons
    },
    setup() {
      const router = useRouter()
      const state = reactive({
        transitionName: 'slide-left',
        isShow: false,// 标识是否在微信浏览器
      })
      router.beforeEach((to, from) => {
        if (to.meta.index > from.meta.index) {
          state.transitionName = 'slide-left' // 向左滑动
        } else if (to.meta.index < from.meta.index) {
          // 由次级到主级
          state.transitionName = 'slide-right'
        } else {
          state.transitionName = ''   // 同级无过渡效果
        }
      })
      const isWXmini = onMounted(() => {
        let ua = navigator.userAgent.toLowerCase();
        let isWeixin = ua.indexOf('micromessenger') !== -1;
        // alert(window.navigator.userAgent)
        if (isWeixin) {
          //微信环境
          state.isShow = true
        }
      })
      const goBack = () => {
        console.log('goBack...');
         window.wx.miniProgram.switchTab({
            url: '/pages/index/index'
         })
      }
      return {
        ...toRefs(state),
        isWXmini,
        goBack
      }
    }
  }
</script>

<style lang="less">

html, body {
  
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

.router-view{
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: 0 auto;
    -webkit-overflow-scrolling: touch;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active{
    height: 100%;
    will-change: transform;
    transition: all 500ms;
    position: absolute;
    backface-visibility: hidden;
}
.slide-right-enter{
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active{
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-enter{
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active{
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}

.van-badge--fixed {
  z-index: 1000;
}
.icons-warp {
    border-radius:50px;
    width: 50px;
    border:1px #fff solid;
    
  .float-icon-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 30px;
      height: auto;
      overflow: hidden;
      padding:6px 0;
      img {
        width: 20px;
        height: 18px;
        margin-top: 3px;
      }
      span {
        font-size: 10px;
        // width: 12px;
        color: #16B0FC;
        font-weight: bold;
        margin-top: 1px;
        // padding-left: 4px;
        // line-height: 13px;
      }
  }
}
</style>
